import { Button, HStack } from '@chakra-ui/react'

interface PaginationProps {
  currentPage: number
  totalPages: number
  onPageChange: (newPage: number) => void
  maxVisiblePages?: number
  isDisabled?: boolean
}

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
  maxVisiblePages = 5,
  isDisabled = false,
}) => {
  const handlePageChange = (newPage: number) => {
    if (newPage >= 1 && newPage <= totalPages && !isDisabled) {
      onPageChange(newPage)
    }
  }

  const visiblePages = Array.from(
    { length: Math.min(maxVisiblePages, totalPages) },
    (_, i) => {
      let pageNum = currentPage - Math.floor(maxVisiblePages / 2) + i
      if (currentPage <= Math.ceil(maxVisiblePages / 2)) pageNum = i + 1
      if (currentPage >= totalPages - Math.floor(maxVisiblePages / 2))
        pageNum = totalPages - maxVisiblePages + 1 + i

      return pageNum > 0 && pageNum <= totalPages ? pageNum : null
    }
  ).filter((pageNum): pageNum is number => pageNum !== null)

  return (
    <HStack mt={4} spacing={1} justify='center'>
      <Button
        size={'xs'}
        border={'1px'}
        borderColor={'gray.200'}
        h={8}
        variant={'solid'}
        borderRadius={'sm'}
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1 || isDisabled}
      >
        Previous
      </Button>
      {visiblePages.map((pageNum) => (
        <Button
          key={pageNum}
          size='xs'
          borderColor={'gray.200'}
          h={6}
          variant={currentPage === pageNum ? 'solid' : 'outline'}
          onClick={() => handlePageChange(pageNum)}
          disabled={isDisabled}
        >
          {pageNum}
        </Button>
      ))}
      <Button
        size={'xs'}
        border={'1px'}
        borderColor={'gray.200'}
        h={8}
        variant={'solid'}
        borderRadius={'sm'}
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages || isDisabled}
      >
        Next
      </Button>
    </HStack>
  )
}
